<template>
  <div id="transactionRelated">
    <a-form
      ref="step1Ref"
      class="ant-round-form material-company-register-form"
      layout="vertical"
      :model="modelForm"
      :rules="rules"
      @finish="submit"
    >
      <!-- 提供的产品和服务 -->
      <a-form-item name="serviceProvided" :label="$t('common_text_005') + $t('pages_merchant_160')">
        <div>
          <div style="color:#BA8438;">{{ $t("pages_merchant_197") }}</div>
          <div style="color:#BA8438; margin-bottom: 10px;">{{ $t("pages_merchant_198") }}</div>
          <div>{{ $t("pages_merchant_199") }}</div>
        </div>
        <a-select
          v-model:value="modelForm.serviceProvided"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.serviceProvidedDisabled"
        >
          <a-select-option
            v-for="item in [
              {
                value: '0',
                key: '货物贸易',
              },
              {
                value: '1',
                key: '服务贸易',
              },
            ]"
            :key="item.value"
            :value="item.value"
          >
            {{ item.key }}
          </a-select-option>
        </a-select>
        <div v-if="!modelForm.serviceProvidedDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.serviceProvidedMessage }}</span>
        </div>
      </a-form-item>
      <!-- 业务性质 -->
      <a-form-item
        v-if="modelForm.serviceProvided === '0'"
        name="businessBackgroundTradeInGoods"
        :label="$t('pages_merchant_158')"
      >
        <a-tree-select
          v-model:value="modelForm.businessBackgroundTradeInGoods"
          style="width: 100%"
          :tree-data="businessTradeInGoods"
          tree-checkable
          allow-clear
          :show-checked-strategy="SHOW_PARENT"
          :placeholder="$t('common_text_005') + $t('pages_merchant_158')"
          tree-node-filter-prop="label"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :disabled="modelForm.businessBackgroundTradeInGoodsDisabled"
        />
        <div v-if="!modelForm.businessBackgroundTradeInGoodsDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.businessBackgroundTradeInGoodsMessage }}</span>
        </div>
      </a-form-item>
      <a-form-item
        v-if="modelForm.serviceProvided === '1'"
        name="businessBackgroundServiceTrade"
        :label="$t('pages_merchant_159')"
      >
        <a-tree-select
          v-model:value="modelForm.businessBackgroundServiceTrade"
          style="width: 100%"
          :tree-data="businessTerviceTrade"
          tree-checkable
          allow-clear
          :show-checked-strategy="SHOW_PARENT"
          placeholder="服务贸易"
          tree-node-filter-prop="label"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :disabled="modelForm.businessBackgroundServiceTradeDisabled"
        />
        <div v-if="!modelForm.businessBackgroundServiceTradeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.businessBackgroundServiceTradeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 运营资金来源 -->
      <a-form-item name="sourceFunds" :label="$t('pages_merchant_011')">
        <div class="explain" style="color:#BA8438;margin-bottom: 10px;">{{ $t("pages_merchant_081") }}</div>
        <div class="header-title">
          {{ $t("pages_merchant_082") }}{{ $t("pages_merchant_083") }}
          <span style="font-size: 12px">{{ $t("pages_merchant_063") }}</span>
        </div>
        <a-select
          v-model:value="modelForm.sourceFunds"
          style="width: 100%"
          :disabled="modelForm.sourceFundsDisabled"
          show-search
          size="large"
          mode="multiple"
          option-filter-prop="label"
          :placeholder="$t('common_text_005') + $t('pages_merchant_011')"
        >
          <a-select-option v-for="item in sourceFunds" :key="item.value" :value="item.value">{{ $t(item.key)
          }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.sourceFundsDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.sourceFundsMessage }}</span>
        </div>
      </a-form-item>
      <!-- 预期付款目的 -->
      <a-form-item name="paymentPurpose" :label="$t('pages_merchant_012')">
        <div class="explain" style="color:#BA8438;margin-bottom: 10px;">{{ $t("pages_merchant_081") }}</div>
        <div class="header-title">
          {{ $t('pages_merchant_084') }}
          <span style="font-size: 12px">{{ $t("pages_merchant_063") }}</span>
        </div>
        <a-select
          v-model:value="modelForm.paymentPurpose"
          style="width: 100%"
          :disabled="modelForm.sourceWhereaboutsDisabled"
          show-search
          size="large"
          mode="multiple"
          option-filter-prop="label"
          :placeholder="$t('common_text_005') + $t('pages_merchant_012')"
        >
          <a-select-option v-for="item in sourceWheres" :key="item.value" :value="item.value">{{ $t(item.key)
          }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.sourceWhereaboutsDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.sourceWhereaboutsMessage }}</span>
        </div>
      </a-form-item>
      <!-- 去年的营业额（USD） -->
      <a-form-item name="saleOneYear_v_two" :label="$t('pages_merchant_162')">
        <a-select
          v-model:value="modelForm.saleOneYear_v_two"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.saleOneYear_v_twoDisabled"
        >
          <a-select-option v-for="item in saleOneYear" :key="item.value" :value="item.value">
            {{ item.key }}
          </a-select-option>
        </a-select>
        <div v-if="!modelForm.saleOneYear_v_twoDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.saleOneYear_v_twoMessage }}</span>
        </div>
      </a-form-item>
      <!-- 预估交易量 (每月)(USD) -->
      <a-form-item name="permonthTransactionAmount_v_two" :label="$t('pages_merchant_163')">
        <a-select
          v-model:value="modelForm.permonthTransactionAmount_v_two"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.permonthTransactionAmount_v_twoDisabled"
        >
          <a-select-option v-for="item in permonthTransactionAmount" :key="item.value" :value="item.value">
            {{ item.key }}
          </a-select-option>
        </a-select>
        <div v-if="!modelForm.permonthTransactionAmount_v_twoDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.permonthTransactionAmount_v_twoMessage }}</span>
        </div>
      </a-form-item>
      <!-- 目前客戶所在国家 -->
      <a-form-item name="currentClientCountryCode" :label="$t('pages_merchant_164')">
        <a-select
          v-model:value="modelForm.currentClientCountryCode"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.currentClientCountryCodeDisabled"
          :options="countryCode"
          mode="multiple"
        />
        <div v-if="!modelForm.currentClientCountryCodeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.currentClientCountryCodeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 交易对手方类型 -->
      <a-form-item name="receiptPaymentParticipantsType" :label="$t('pages_merchant_165')">
        <a-select
          v-model:value="modelForm.receiptPaymentParticipantsType"
          show-search
          size="large"
          option-filter-prop="label"
          mode="multiple"
          :disabled="modelForm.receiptPaymentParticipantsTypeDisabled"
        >
          <a-select-option
            v-for="item in [
              {
                value: '0',
                key: 'pages_pay_375'
              },
              {
                value: '1',
                key: 'pages_pay_207'
              }
            ]
            "
            :key="item.value"
            :value="item.value"
          >
            {{ $t(item.key) }}
          </a-select-option>
        </a-select>
        <div v-if="!modelForm.receiptPaymentParticipantsTypeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.receiptPaymentParticipantsTypeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 在哪个国家/地区经营（开展）业务 -->
      <a-form-item name="allCountry" :label="$t('pages_merchant_166')">
        <a-select
          v-model:value="modelForm.allCountry"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.allCountryDisabled"
          :options="countryCode"
          mode="multiple"
        />
        <div v-if="!modelForm.allCountryDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.allCountryMessage }}</span>
        </div>
      </a-form-item>
      <!-- 目前合作伙伴/供应商所在国家 -->
      <a-form-item name="currentSuppliersCountryCode" :label="$t('pages_merchant_167')">
        <a-select
          v-model:value="modelForm.currentSuppliersCountryCode"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.currentSuppliersCountryCodeDisabled"
          :options="countryCode"
          mode="multiple"
        />
        <div v-if="!modelForm.currentSuppliersCountryCodeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.currentSuppliersCountryCodeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 目前和预计需要的收款服务的汇入国家 -->
      <a-form-item name="exToCollectionServicesReCountriesCode" :label="$t('pages_merchant_168')">
        <a-select
          v-model:value="modelForm.exToCollectionServicesReCountriesCode"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.exToCollectionServicesReCountriesCodeDisabled"
          :options="countryCode"
          mode="multiple"
        />
        <div v-if="!modelForm.exToCollectionServicesReCountriesCodeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.exToCollectionServicesReCountriesCodeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 目前和预计需要的付款服务的汇出国家 -->
      <a-form-item name="exFromCollectionServicesReCountriesCode" :label="$t('pages_merchant_169')">
        <a-select
          v-model:value="modelForm.exFromCollectionServicesReCountriesCode"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.exFromCollectionServicesReCountriesCodeDisabled"
          :options="countryCode"
          mode="multiple"
        />
        <div v-if="!modelForm.exFromCollectionServicesReCountriesCodeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.exFromCollectionServicesReCountriesCodeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 交易模式 -->
      <a-form-item name="distributionChannels" :label="$t('pages_merchant_171')">
        <a-select
          v-model:value="modelForm.distributionChannels"
          show-search
          size="large"
          option-filter-prop="label"
          :disabled="modelForm.distributionChannelsDisabled"
          :options="distributionChannels"
          mode="multiple"
        />
        <div v-if="!modelForm.distributionChannelsDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.distributionChannelsMessage }}</span>
        </div>
      </a-form-item>
      <!-- "当交易模式选择线上交易，并通过Web或APP销售，请输入网址或应用程序名称" -->
      <a-form-item
        v-if="modelForm.distributionChannels.find(item => item.indexOf('online') !== -1)"
        name="enterURLOrAppName"
        :label="$t('common_text_006') + $t('pages_merchant_170')"
      >
        <a-input
          v-model:value="modelForm.enterURLOrAppName"
          size="large"
          allow-clear
          :placeholder="$t('common_text_006') + $t('pages_merchant_170')"
        />
      </a-form-item>
      <!-- 员工人数 -->
      <a-form-item
        name="employeeNumber"
        :label="$t('pages_merchant_174')"
      >
        <a-input
          v-model:value="modelForm.employeeNumber"
          size="large"
          allow-clear
          :disabled="modelForm.employeeNumberDisabled"
          :placeholder="$t('common_text_006') + $t('pages_merchant_174')"
        />
        <div v-if="!modelForm.employeeNumberDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.employeeNumberMessage }}</span>
        </div>
      </a-form-item>
      <!-- 公司官网 -->
      <a-form-item
        name="companyWebsite"
        :label="$t('pages_merchant_173')"
      >
        <a-input
          v-model:value="modelForm.companyWebsite"
          size="large"
          allow-clear
          :disabled="modelForm.companyWebsiteDisabled"
          :placeholder="$t('common_text_006') + $t('pages_merchant_173')"
        />
        <div v-if="!modelForm.companyWebsiteDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.companyWebsiteMessage }}</span>
        </div>
      </a-form-item>
      <!-- 下一步按钮 -->
      <a-form-item style="text-align: right">
        <a-button
          type="primary"
          shape="round"
          ghost
          style="min-width: 138px; margin-right: 24px"
          @click="$emit('next', '2-6')"
        >{{ $t("pages_merchant_040") }}</a-button>
        <a-button html-type="submit" type="primary" shape="round" style="min-width: 138px; margin-top: 24px">{{
          $t("pages_merchant_020") }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed, onUnmounted, nextTick } from 'vue'
import companyAddressType from '@/common/companyAddressType'
import merchantRregistrationType from '@/common/merchantRregistrationType'
import businessTerviceTrade from '@/common/businessTerviceTrade'
import businessTradeInGoods from '@/common/businessTradeInGoods'
import sourceFunds from '@/common/sourceFunds'
import sourceWheres from '@/common/sourceWheres'
import saleOneYear from '@/common/saleOneYear'
import countryCode from '@/common/countryCode'
import permonthTransactionAmount from '@/common/permonthTransactionAmount'
import distributionChannels from '@/common/distributionChannels'

import i18n from '@/locale'
export default {
  name: 'TransactionRelated',
  props: {
    model: {
      type: Object,
      default: () => {
        return {}
      }
    },
    refused: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    countries: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup(props, ctx) {
    const uploadRef = ref(null)
    const step1Ref = ref(null)
    const state = reactive({
      exist: false,
      language: localStorage.getItem('locale-language') || 'zh',
      rules: {
        sourceFunds: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_011') }
        ],
        paymentPurpose: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_012') }
        ],
        businessBackgroundTradeInGoods: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_158') }
        ], // 业务性质货物贸易
        businessBackgroundServiceTrade: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_159') }
        ], // 业务性质服务贸易
        serviceProvided: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_160') }
        ], // 提供的产品和服务
        saleOneYear_v_two: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_162') }
        ], // 去年的营业额（USD）
        permonthTransactionAmount_v_two: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_163') }
        ], // 预估交易量 (每月)(USD)
        currentClientCountryCode: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_164') }
        ], // 目前客戶所在国家
        receiptPaymentParticipantsType: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_165') }
        ], // 交易对手方类型
        allCountry: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_166') }
        ], // 在哪个国家/地区经营（开展）业务？
        currentSuppliersCountryCode: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_167') }
        ], // 目前合作伙伴/供应商所在国家
        exToCollectionServicesReCountriesCode: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_168') }
        ], // 目前和预计需要的收款服务的汇入国家
        exFromCollectionServicesReCountriesCode: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_169') }
        ], // 目前和预计需要的付款服务的汇出国家
        distributionChannels: [
          { required: true, message: i18n.global.t('common_text_005') + i18n.global.t('pages_merchant_171') }
        ], // 交易模式
        employeeNumber: [
          { required: true, message: i18n.global.t('common_text_006') + i18n.global.t('pages_merchant_174') }
        ]// 公司官网
      }
    })

    state.modelForm = computed(() => {
      console.log(props.model, 'props.model+++++++++++++++')
      return props.model
    })

    onUnmounted(() => {
      if (state.modelForm.serviceProvided === '1') {
        state.modelForm.businessBackgroundTradeInGoods = []
      } else {
        state.modelForm.businessBackgroundServiceTrade = []
      }
    })

    const submit = () => {
      ctx.emit('next', '3-2')
    }

    nextTick(() => {
      // const { proofOfRealBusinessAddress } = state.modelForm
      // if (proofOfRealBusinessAddress.length !== 0 && uploadRef.value) { uploadRef.value.fileListRefresh(proofOfRealBusinessAddress) }
    })
    return {
      step1Ref,
      submit,
      uploadRef,
      companyAddressType,
      merchantRregistrationType,
      businessTerviceTrade,
      businessTradeInGoods,
      sourceFunds,
      sourceWheres,
      saleOneYear,
      countryCode,
      permonthTransactionAmount,
      distributionChannels,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#transactionRelated {
}
</style>
